const getLoginType = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const loginType = urlParams.get("loginType");
  const validTypes = ["cliente", "agente", "super-admin"];

  if (!loginType || !validTypes.includes(loginType)) {
    return "cliente";
  }

  return loginType;
};

export default getLoginType;
